import { FC, ReactNode } from 'react';
import { ToastProvider } from './toast-provider';
import { AssessmentParamProvider } from './AssessmentParamContext';
import { CandidateProvider } from './CandidateContext';
import { UserProvider } from './UserContext';
import { DepartmentProvider } from './DepartmentContext';
import { CompanyProvider } from './CompanyContext';
import { PredefinedGraphsProvider } from './PredefinedGraphsContext';
import { DashboardChartsProvider } from './DashboardChartsContext';
import { JobDescriptionProvider } from './JobDescriptionContext';
import { MarleeProvider } from './MarleeContext';

// Define the props interface for context provider components.

/**
 * Combines an array of context provider components into a single provider component.
 *
 * @param providers - An array of context provider components to combine. Defaults to an empty array.
 * @returns A React component that renders the combined context providers.
 */
const combineContextProviders = (providers = []) => {
  const CombinedProviders = providers.reduce((AccumulatedProviders, CurrentProvider) => {
    const Combined = ({
      children
    }) => <AccumulatedProviders>
                    <CurrentProvider>{children}</CurrentProvider>
                </AccumulatedProviders>;
    // Set display name for the combined component
    Combined.displayName = `Combined(${AccumulatedProviders.displayName || 'Component'}_${CurrentProvider.displayName || 'Component'})`;
    return Combined;
  }, ({
    children
  }) => <>{children}</>);

  // Set display name for the base component
  CombinedProviders.displayName = 'CombinedProviders';
  return CombinedProviders;
};

// Create a context provider component that combines the providers
const ContextProvider = combineContextProviders([ToastProvider, AssessmentParamProvider, CandidateProvider, UserProvider, DepartmentProvider, CompanyProvider, PredefinedGraphsProvider, DashboardChartsProvider, JobDescriptionProvider, MarleeProvider]);

// Set display name for the main context provider
ContextProvider.displayName = 'ContextProvider';
export default ContextProvider;